type BazaArticleReadingSegments = {
  collectionSlug: string
  articleSlug: string
}

const NON_ARTICLE_THIRD_SEGMENTS = new Set([
  'manage',
  'upsert',
  'settings',
  'history',
  'new-version',
  'preview'
])

export function getBazaArticleReadingSegments(pathname: string): BazaArticleReadingSegments | null {
  const segments = pathname.split('/').filter(Boolean)

  if (segments.length !== 3 || segments[0] !== 'baza') {
    return null
  }

  if (NON_ARTICLE_THIRD_SEGMENTS.has(segments[2])) {
    return null
  }

  return {
    collectionSlug: segments[1],
    articleSlug: segments[2]
  }
}
